module.exports = __webpack_public_path__ + "static/slide1left-cd83a64f448adc533cfd3a5fc6bd34fb.webp";